import { Record } from 'immutable';

export default class DomainRecord extends Record({
  id: undefined,
  createdAt: undefined,
  name: undefined,
  spfConfiguredAt: undefined,
}) {
}
